module.exports = __webpack_public_path__ + "img/Soft Drinks.43c6691f.svg";